<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete', 'start', 'pause', 'cancel']);

const handleEdit   = campaign => emit('edit',   campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleStart  = campaign => emit('start',  campaign);
const handlePause  = campaign => emit('pause',  campaign);
const handleCancel = campaign => emit('cancel', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :campaign-id="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @start="handleStart(campaign)"
      @pause="handlePause(campaign)"
      @cancel="handleCancel(campaign)"
    />
  </div>
</template>
